import { Component } from '@angular/core';

@Component({
  selector: 'route-not-authorized',
  templateUrl: './not-authorized.component.html',
  styleUrls: ['./not-authorized.component.scss'],
  standalone: true,
})
export class NotAuthorizedComponent {}
